import React, { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { Bell, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const KIND_STYLE = {
  action: { bg: "#FEE2E2", color: "#991B1B" },
  reminder: { bg: "#FEF3C7", color: "#92400E" },
  tip: { bg: "#DBEAFE", color: "#1E40AF" },
  weekly: { bg: "#DCFCE7", color: "#166534" },
};

export default function NotificationsBell() {
  const [data, setData] = useState({ count: 0, items: [] });

  useEffect(() => {
    let mounted = true;
    api.get("/notifications/").then((r) => { if (mounted) setData(r.data); }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notifications-bell" className="relative w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-slate-200 transition">
          <Bell className="w-4 h-4" />
          {data.count > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] rounded-full bg-coral-500 text-[10px] font-bold flex items-center justify-center px-1 text-white" style={{ background: "#FB7185" }}>
              {data.count}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0 bg-white border-slate-200 shadow-2xl">
        <div className="px-4 py-3 border-b border-slate-100">
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold">Notifications</p>
          <p className="font-display text-lg text-slate-900">{data.count} new</p>
        </div>
        <div className="max-h-[400px] overflow-y-auto">
          {data.items.length === 0 && <p className="p-6 text-center text-sm text-slate-500">You&apos;re all caught up!</p>}
          {data.items.map((n) => {
            const s = KIND_STYLE[n.kind] || KIND_STYLE.tip;
            const Wrapper = n.to ? Link : "div";
            return (
              <Wrapper key={n.id} to={n.to || undefined} data-testid={`notif-${n.id}`} className="block px-4 py-3 border-b border-slate-100 hover:bg-slate-50">
                <div className="flex items-start gap-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full font-bold flex-shrink-0" style={{ background: s.bg, color: s.color }}>
                    {n.kind}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold text-slate-900">{n.title}</p>
                    <p className="text-xs text-slate-600 mt-0.5">{n.body}</p>
                    {n.cta && (
                      <p className="text-xs font-bold mt-2 flex items-center gap-1" style={{ color: "#3B82F6" }}>
                        {n.cta} <ArrowRight className="w-3 h-3" />
                      </p>
                    )}
                  </div>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
